export * from './post-besichtigungs-status-request.interface';
export * from './post-besichtigungs-status-response.interface';
export * from './post-besichtigungs-status.shapes';
